<template>
    <v-dialog v-model="thisValue" persistent max-width="800px">
  
      <material-card color="green" title="编辑商家信息">
        <v-form>
          <v-container py-0>
            <v-flex wrap>
              <v-flex xs12 md6>
                <v-text-field label="校区ID" v-model="thisMsg.a_id" disabled />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="店铺名称" v-model="thisMsg.s_name"  />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="店铺简介" v-model="thisMsg.s_detail"  />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="店铺地址" v-model="thisMsg.s_address"  />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="序号" v-model="thisMsg.sort"  />
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field class="purple-input" v-model="thisMsg.s_phone" label="联系电话" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field class="purple-input" v-model="thisMsg.profit.pei" label="配送费" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field class="purple-input" v-model="thisMsg.profit.shget" label="商家费率" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field class="purple-input" v-model="thisMsg.profit.dlget" label="代理费率" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field class="purple-input" v-model="thisMsg.profit.ptget" label="平台费率" :readonly="userRole == 'user'" />
              </v-flex>
            
              
              <v-flex xs12 md6>
                <v-text-field label="总盈利额" disabled v-model="thisMsg.s_balance"  class="purple-input" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="已提现额" disabled v-model="thisMsg.s_cash"  class="purple-input" />
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field label="小票机SN" v-model="thisMsg.p_sn"  class="purple-input" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="小票机User"  v-model="thisMsg.p_user"  class="purple-input" />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="小票机Ukey" v-model="thisMsg.p_ukey"  class="purple-input" />
              </v-flex>
              <v-flex xs12 md6>
                <v-select v-model="thisMsg.s_type"
              :items="[ { label: '大餐厅商户', value: 1 }, { label: '商业街商户', value: 2 }]"
              label="商户类别" item-text="label" item-value="value" ></v-select>
              </v-flex>

              <v-flex xs6 md6>
                
                <v-select v-model="thisMsg.p_on"
              :items="[ { label: '启用', value: true }, { label: '禁用', value: false }]"
              label="是否启用小票机" item-text="label" item-value="value" ></v-select>
              </v-flex>


              <v-flex xs6 md6>
                
                <v-select v-model="thisMsg.s_show"
              :items="[ { label: '通过', value: true }, { label: '拒绝', value: false }]"
              label="审核状态" item-text="label" item-value="value" ></v-select>
              </v-flex>
            <v-flex xs6 md6>
              <v-select v-model="thisMsg.s_status"
              :items="[ { label: '营业中', value: true }, { label: '休息中', value: false }]"
              label="营业状态" item-text="label" item-value="value" ></v-select>
              </v-flex>
              <v-flex xs6 md6 v-show = "userRole == 'admin'" >
              <v-select v-model="thisMsg.can_cash"
              :items="[ { label: '正常', value: true }, { label: '冻结', value: false }]"
              label="是否允许提现" item-text="label" item-value="value" ></v-select>
              </v-flex>
              
              <v-flex xs12 text-xs-right>
                <v-btn color="blue gray" text @click="thisValue = false">关闭</v-btn>
                <v-btn class="mx-0 font-weight-light" style="margin-left: 100px;" @click="doUpdate()" color="success">
                  保存
                </v-btn>
              </v-flex>
        </v-flex>
          </v-container>
        </v-form>
  
      </material-card>
    </v-dialog>
  </template>
  
  <script>
  let _this;
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
        default: false
      },
      msg: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        thisValue: this.value,
        thisMsg: JSON.parse(JSON.stringify(this.msg)),
        loading: false,
        userRole: sessionStorage.getItem('role'),
        roles: []
      };
    },
    watch: {
      value(newVal) {
        this.thisValue = newVal;
      },
      thisValue(newVal) {
        this.$emit("change", newVal);
      },
      msg(val) {
        this.thisMsg = val;
      }
    },
    mounted() {
      _this = this;
  
    },
    methods: {
  
    async   doUpdate() {
        if(this.thisMsg.profit.shget*100 + this.thisMsg.profit.dlget*100 + this.thisMsg.profit.ptget*100 != 100){
         this.$message({
            message:'分成费率填写错误！',
            type:'warning'
         })
         return false
        }

        this.loading = true;
      const res = await  this.$post(
          "admin/updateMerchantInfo",
          this.thisMsg,  
        )
         {
            _this.loading = false;
            if (res.errno == 0) {
              _this.$message({
                showClose: true,
                message: res.errmsg,
                type: "success"
              });
              _this.thisValue = false;
              _this.$emit("changemsg", res);
            }
          }
      }
    }
  };
  </script>
  